(function() { window.GUID_4c95b532_186a_4773_ba88_c3d2a4e0dbc5 = { getGuid: function() { return "4c95b532-186a-4773-ba88-c3d2a4e0dbc5"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SnackbarAnimation;
        (function (SnackbarAnimation) {
            SnackbarAnimation[SnackbarAnimation["Fade"] = 0] = "Fade";
            SnackbarAnimation[SnackbarAnimation["SlideUp"] = 1] = "SlideUp";
            SnackbarAnimation[SnackbarAnimation["SlideDown"] = 2] = "SlideDown";
        })(SnackbarAnimation = Enumeration.SnackbarAnimation || (Enumeration.SnackbarAnimation = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SnackbarAnimation.pre.js.map
